/** The web keeps no local copies of documents: nothing to forget. */
export async function forgetLocalDocuments(): Promise<number> {
  return 0;
}
